import clsx from 'clsx';
import React from 'react';

import {
  alignmentValues,
  backgroundColorValues,
  fontFamilyValues,
  fontSizeValues,
  gridValues,
  isFlex,
  marginValues,
  paddingValues,
  verticalAlignmentValues,
} from './constants';

function SectionBlock({ config, children }) {
  return (
    <section
      className={clsx(
        'section-block',
        config?.wrap ? 'flex-wrap' : 'flex-nowrap',
        config?.css_classes,
        alignmentValues[config?.alignment],
        backgroundColorValues[config?.background_color],
        fontFamilyValues[config?.font_family],
        fontSizeValues[config?.font_size],
        marginValues[config?.margin],
        paddingValues[config?.padding],
        gridValues[config?.layout],
        isFlex(config?.layout) && verticalAlignmentValues[config?.vertical_alignment]
      )}
    >
      {children}
    </section>
  );
}

export default SectionBlock;
